var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoqqArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 37,
    viewBox: "0 0 46 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1997 0.679688H9.77969C4.61582 0.679688 0.429688 4.86582 0.429688 10.0297V26.7597C0.429688 31.9235 4.61582 36.1097 9.77969 36.1097H36.1997C41.3635 36.1097 45.5497 31.9235 45.5497 26.7597V10.0297C45.5497 4.86582 41.3635 0.679688 36.1997 0.679688Z",
    fill: "url(#paint0_linear_9784_147385)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5397 4.10938H11.4397C7.29203 4.10938 3.92969 7.47172 3.92969 11.6194V25.1594C3.92969 29.307 7.29203 32.6694 11.4397 32.6694H34.5397C38.6873 32.6694 42.0497 29.307 42.0497 25.1594V11.6194C42.0497 7.47172 38.6873 4.10938 34.5397 4.10938Z",
    fill: "#11560D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.65 7.92969H11.33C7.83404 7.92969 5 10.7637 5 14.2597V22.0797C5 25.5756 7.83404 28.4097 11.33 28.4097H34.65C38.146 28.4097 40.98 25.5756 40.98 22.0797V14.2597C40.98 10.7637 38.146 7.92969 34.65 7.92969Z",
    fill: "#56CE4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.98 22.0898V25.3198C40.98 28.8098 38.15 31.6498 34.65 31.6498H11.33C7.84 31.6498 5 28.8198 5 25.3198V22.0898C5 25.5798 7.83 28.4198 11.33 28.4198H34.65C38.14 28.4198 40.98 25.5898 40.98 22.0898Z",
    fill: "#1C9116"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.65 7.92969H11.33C7.83404 7.92969 5 10.7637 5 14.2597V22.0797C5 25.5756 7.83404 28.4097 11.33 28.4097H34.65C38.146 28.4097 40.98 25.5756 40.98 22.0797V14.2597C40.98 10.7637 38.146 7.92969 34.65 7.92969Z",
    fill: "#56CE4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.98 11.4599V14.2599C40.98 10.7599 38.15 7.92988 34.65 7.92988H11.33C7.84 7.92988 5 10.7599 5 14.2599V11.4599C5 7.96988 7.83 5.12988 11.33 5.12988H34.65C38.14 5.12988 40.98 7.95988 40.98 11.4599Z",
    fill: "#79F763"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.65 7.92969H11.33C7.83404 7.92969 5 10.7637 5 14.2597V22.0797C5 25.5756 7.83404 28.4097 11.33 28.4097H34.65C38.146 28.4097 40.98 25.5756 40.98 22.0797V14.2597C40.98 10.7637 38.146 7.92969 34.65 7.92969Z",
    fill: "url(#paint1_linear_9784_147385)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M20.7206 20.0699C20.8906 19.6599 20.8906 19.1999 20.7206 18.7899L18.5506 13.6999C18.4006 13.2299 18.9006 12.8099 19.3406 13.0299L30.6306 18.8299C31.1206 19.0799 31.1206 19.7699 30.6306 20.0199L19.3406 25.8199C18.9006 26.0499 18.4006 25.6299 18.5506 25.1499L20.7206 20.0599V20.0699Z",
    fill: "#020202"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4804 19.4996C20.6504 19.0896 20.6504 18.6296 20.4804 18.2196L18.3104 13.1296C18.1604 12.6596 18.6604 12.2396 19.1004 12.4596L30.3904 18.2596C30.8804 18.5096 30.8804 19.1996 30.3904 19.4496L19.1004 25.2496C18.6604 25.4796 18.1604 25.0596 18.3104 24.5796L20.4804 19.4896V19.4996Z",
    fill: "url(#paint2_linear_9784_147385)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9784_147385",
    x1: 22.9097,
    y1: 5.40969,
    x2: 23.1197,
    y2: 41.8897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBD9D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9784_147385",
    x1: 22.88,
    y1: 6.17969,
    x2: 23.08,
    y2: 27.8897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#56CE4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#53C64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4CB243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#49AA41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9784_147385",
    x1: 23.7104,
    y1: 16.7796,
    x2: 25.0004,
    y2: 24.8296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBD9D0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoqqArrow);
export default __webpack_public_path__ + "static/media/roqq-arrow.c3e1a889c391fe730b37a2384f434eb9.svg";
export { ForwardRef as ReactComponent };